//挂载埋点入口文件
import mixpanel from 'mixpanel-browser'
import { IS_CHINA } from '@/config'
const isHuoShan = () => {
  let script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src =
    'https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/5.0/collect-rangers-v5.1.6.js'
  document.body.appendChild(script)
}

const pointEvent = (win, export_obj) => {
  if (IS_CHINA) {
    isHuoShan()
    win['LogAnalyticsObject'] = export_obj
    if (!win[export_obj]) {
      // eslint-disable-next-line no-inner-declarations
      function _collect() {
        _collect.q.push(arguments)
      }
      _collect.q = _collect.q || []
      win[export_obj] = _collect
    }
    win[export_obj].l = +new Date()
  } else {
    window.mixpanel = mixpanel
  }
}
export default pointEvent
